module.exports = __webpack_public_path__ + "img/symbol_5.f20a4ad2.png";